import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface PaymentMethod {
  id: string;
  name: string;
  description?: string;
  code: string;
  isActive: boolean;
  requiresReference: boolean;
  isElectronic: boolean;
  displayOrder: number;
}

export interface ApiResponse<T> {
  success: boolean;
  requestResult?: T;
  /** @deprecated Preferir requestResult; la API puede no enviar body. */
  body?: T;
  message?: string;
  errors?: any[];
}

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodsService {
  private apiUrl = `${environment.apiBaseUrl}/api/v1/PaymentMethods`;

  constructor(private http: HttpClient) { }

  getAllPaymentMethods(): Observable<ApiResponse<PaymentMethod[]>> {
    return this.http.get<ApiResponse<PaymentMethod[]>>(this.apiUrl);
  }

  getActivePaymentMethods(): Observable<ApiResponse<PaymentMethod[]>> {
    return this.http.get<ApiResponse<PaymentMethod[]>>(`${this.apiUrl}/active`);
  }

  getPaymentMethodById(id: string): Observable<ApiResponse<PaymentMethod>> {
    return this.http.get<ApiResponse<PaymentMethod>>(`${this.apiUrl}/${id}`);
  }

  /** Deshabilita el método (PATCH; no borra el registro). */
  disablePaymentMethod(id: string): Observable<ApiResponse<void>> {
    return this.http.patch<ApiResponse<void>>(`${this.apiUrl}/${id}/disable`, {});
  }

  /** Habilita el método previamente deshabilitado. */
  enablePaymentMethod(id: string): Observable<ApiResponse<void>> {
    return this.http.patch<ApiResponse<void>>(`${this.apiUrl}/${id}/enable`, {});
  }
}
